import React from "react";
import {BtnBlueFilled, BtnBlueOutlined} from "../../../../../Buttons";

import Input from '../Input';
import DeleteBtn from '../DeleteBtn';

export default ({
  clickOnUpload,

  uploadFile,
  reUploadFile,
  deleteFile,

  id,
  value = [],
  loading,
  disabled
}) => {

  const inputId = `${id}Input`;

  const btnProps = {
    onClick: clickOnUpload(inputId),
    disabled,
    loading,
    heightMedium: true
  };

  const btnDisplay = !value.length
    ? (
      <BtnBlueFilled {...btnProps}>
        Upload +
      </BtnBlueFilled>
    ) : (
      <BtnBlueOutlined className="merchant-upload__item-btn" {...btnProps}>
        <span>
          {value[0].name}
        </span>
        <DeleteBtn
          onClick={deleteFile(value[0].id)}
        />
      </BtnBlueOutlined>
    );

  return (
    <>
      {btnDisplay}
      <Input
        id={inputId}
        onChange={value.name ? reUploadFile('0') : uploadFile}
        disabled={disabled || loading}
      />
    </>
  )
};
